import React, {useEffect, useState} from 'react';
import {Dialog} from "primereact/dialog";

import {Button} from "primereact/button";
import {useEntityObject} from "../dynamic365";
import StringMap from "../dynamic365/entities/StringMap";


function CustomHeader({title, setVisible}) {
    return(
        <div className="flex justify-content-between align-items-center p-3 pb-0">
            <span className="pi pi-times cursor-pointer" onClick={()=>{setVisible(false)}}/>
            <span>{title}</span>
        </div>
    )
}

function OptionTypesDialog({visible, setVisible, title, attributeName, entityTypeCode, onSelect}) {
    const stringMap = useEntityObject(StringMap());
    const [optionSet, setOptionSet] = useState([]);
    useEffect(()=>{
        if (visible){
            stringMap.fetchLocal({
                onResult:(result)=>{

                    let optionSet = result.data.value.filter((data)=>(data['attributename']===attributeName))
                    // console.log(optionSet)
                    setOptionSet(optionSet)
                    // support.dispatch({type:types.SET_OPTIONSETS, attributeName ,optionSet})
                }
            })
        }
    },[visible])
    return (
        <Dialog visible={visible} onHide={()=>{setVisible(false)}} className="w-10 lg:w-4" contentClassName="p-0 border-round-2xl" closeOnEscape={true} showHeader={false}>
            <>
                <CustomHeader setVisible={setVisible} title={title}/>
                <div className="flex flex-column gap-2 p-3">
                    {
                        optionSet.map((o)=>(<Button className="bg-gray-200 hover:bg-gray-300 border-none text-gray-800 justify-content-center" key={o.stringmapid} onClick={()=>{onSelect(o)}}>{o['_value@OData.Community.Display.V1.FormattedValue']}</Button>))
                    }
                </div>
            </>
        </Dialog>
    );
}

export default OptionTypesDialog;